import { AdminAnalytics, AuditLogItem, UserProfile, BreachRecord } from '../types';
import { INITIAL_ANALYTICS, INITIAL_AUDIT_LOGS, INITIAL_USER } from '../data/mockState';
import { KNOWN_BREACHES } from '../data/breaches';

const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

const ANALYTICS_KEY = 'idfraud_admin_analytics';
const BREACHES_KEY = 'idfraud_breaches_db';
const AUDIT_KEY = 'idfraud_audit_logs';

export async function getAdminAnalytics(): Promise<AdminAnalytics> {
  await delay(300);
  const raw = localStorage.getItem(ANALYTICS_KEY);
  if (raw) {
    try { return JSON.parse(raw); } catch {}
  }
  localStorage.setItem(ANALYTICS_KEY, JSON.stringify(INITIAL_ANALYTICS));
  return INITIAL_ANALYTICS;
}

export async function getAdminUsersList(): Promise<UserProfile[]> {
  await delay(350);
  return [
    INITIAL_USER,
    {
      id: 'usr_au_1029',
      firstName: 'Sophie',
      lastName: 'Taylor',
      email: 'sophie.taylor@melbourne-legal.com.au',
      phone: '+61 433 902 114',
      country: 'Australia',
      marketingConsent: true,
      role: 'user',
      mfaEnabled: true,
      createdAt: '2026-02-10T14:10:00Z',
      lastLoginAt: '2026-08-19T18:20:00Z'
    },
    {
      id: 'usr_au_1030',
      firstName: 'David',
      lastName: 'Nguyen',
      email: 'david.n@brisbane-tech.com.au',
      phone: '+61 411 773 205',
      country: 'Australia',
      marketingConsent: false,
      role: 'user',
      mfaEnabled: false,
      createdAt: '2026-04-05T09:00:00Z',
      lastLoginAt: '2026-08-18T10:45:00Z'
    },
    {
      id: 'usr_au_admin_01',
      firstName: 'Security',
      lastName: 'Administrator',
      email: 'admin@idfraud.au',
      phone: '+61 2 8000 9000',
      country: 'Australia',
      marketingConsent: false,
      role: 'admin',
      mfaEnabled: true,
      createdAt: '2026-01-01T00:00:00Z',
      lastLoginAt: new Date().toISOString()
    }
  ];
}

export async function getAdminBreaches(): Promise<BreachRecord[]> {
  await delay(300);
  const raw = localStorage.getItem(BREACHES_KEY);
  if (raw) {
    try { return JSON.parse(raw); } catch {}
  }
  localStorage.setItem(BREACHES_KEY, JSON.stringify(KNOWN_BREACHES));
  return KNOWN_BREACHES;
}

export async function addAdminBreach(breach: Omit<BreachRecord, 'id' | 'addedDate'>): Promise<BreachRecord> {
  await delay(400);
  const raw = localStorage.getItem(BREACHES_KEY);
  const list: BreachRecord[] = raw ? JSON.parse(raw) : KNOWN_BREACHES;
  const newBreach: BreachRecord = {
    ...breach,
    id: breach.organisation.toLowerCase().replace(/[^a-z0-9]/g, '-') + '-' + Date.now(),
    addedDate: new Date().toISOString().split('T')[0]
  };
  list.unshift(newBreach);
  localStorage.setItem(BREACHES_KEY, JSON.stringify(list));
  return newBreach;
}

export async function getAdminAuditLogs(): Promise<AuditLogItem[]> {
  await delay(250);
  const raw = localStorage.getItem(AUDIT_KEY);
  if (raw) {
    try { return JSON.parse(raw); } catch {}
  }
  localStorage.setItem(AUDIT_KEY, JSON.stringify(INITIAL_AUDIT_LOGS));
  return INITIAL_AUDIT_LOGS;
}
